module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Regular.woff
// module id = 269
// module chunks = 0